/**
 * GENERATED FILE — do not edit by hand.
 *
 * Source of truth: Firestore database `mediadb`, collection `assets/`.
 * Regenerated by `node scripts/fetch-media-assets.mjs` (runs automatically
 * before `vite build` when a service account is available).
 *
 * Committed to git so:
 *   - Local builds work without a service account (uses the snapshot).
 *   - PR diffs surface asset URL changes.
 *   - mediadb downtime doesn't break the build.
 */

import type { MediaAsset } from '@app-types/media-asset';

export const MEDIA_ASSETS: Record<string, MediaAsset> = {
  "ai_uneven_impact_dark_blog": {
    "name": "ai_uneven_impact_dark_blog",
    "type": "gif",
    "url": "https://storage.googleapis.com/the-home-ceo-media/blog_images/ai_uneven_impact_dark_v1.gif",
    "version": 1
  },
  "calm_water_background": {
    "name": "calm_water_background",
    "type": "image",
    "url": "https://storage.googleapis.com/the-home-ceo-media/background/calm_water_v1.png",
    "version": 1
  },
  "family_planner_hero": {
    "name": "family_planner_hero",
    "type": "image",
    "url": "https://storage.googleapis.com/the-home-ceo-media/use_case_heroes_v3/family_planner_v3.png",
    "version": 3
  },
  "house_shimmer_slate_icon_variation": {
    "name": "house_shimmer_slate_icon_variation",
    "type": "image",
    "url": "https://storage.googleapis.com/the-home-ceo-media/homeceo/icon_variations/house_shimmer_slate_v1.png",
    "version": 1
  }
};

export const MEDIA_URLS: Record<string, string> = {
  "ai_uneven_impact_dark_blog": "https://storage.googleapis.com/the-home-ceo-media/blog_images/ai_uneven_impact_dark_v1.gif",
  "calm_water_background": "https://storage.googleapis.com/the-home-ceo-media/background/calm_water_v1.png",
  "family_planner_hero": "https://storage.googleapis.com/the-home-ceo-media/use_case_heroes_v3/family_planner_v3.png",
  "house_shimmer_slate_icon_variation": "https://storage.googleapis.com/the-home-ceo-media/homeceo/icon_variations/house_shimmer_slate_v1.png"
};

export const SYNCED_AT: string = "2026-08-24T19:37:15.106Z";
